import * as React from "react";
const SvgConnectStripe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <g clipPath="url(#connectStripe_svg__a)">
      <path fill="#082B60" d="M0 6.364 28 0v22.91L0 28z" />
    </g>
    <defs>
      <clipPath id="connectStripe_svg__a">
        <path fill="#fff" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgConnectStripe;
